import S3Service from "../../service/s3Service";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import ApiServices from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import { Alert, RoundedTab, RoundedTabGroup } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../utils/apiConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import ErrorHandler from "../../utils/errorConfig";
import { Loading } from "../common/loading";
import { Button } from "@progress/kendo-react-buttons";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AuthService from "../../service/authService";
import { jwtDecode } from "jwt-decode";
import { LoaderFileUpload } from "../common/loaderFileUpload";

export interface UploadFileProps {
  uploadDialogFunction?: Function;
  uploadDialogValue?: Boolean;
  searchUserState?: Function;
  triggerFetchAll?: Function;
  triggerFetchBool?: Boolean;
}

export function UploadFile(props: UploadFileProps) {
  const navigate = useNavigate();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [userId, setUserId] = useState<string>();
  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  const [uploadUser, setUploadUser] = useState<any>();
  const [uploadFile, setUploadFile] = useState<any>();
  const [fileSuccessDialog, setFileSuccessDialog] =
    React.useState<boolean>(false);
  const [downloadSuccessDialog, setDownloadSuccessDialog] =
    useState<boolean>(false);

  //loader for uplad file
  const [loader, setLoader] = React.useState<boolean>(false);
  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [fileNotChosenDialog, setFileNotChosenDialog] =
    useState<boolean>(false);
  const [fileNotLodingDialog, setFileNotLoadingDialog] =
    useState<boolean>(false);

  const intl = useIntl();

  const toggleTemplateSuccessDialog = () => {
    setDownloadSuccessDialog(!downloadSuccessDialog);
  };

  function resetTabs(tabName: string) {}

  console.log("upload user template link", uploadUser?.link);

  const toggleFileSuccessDialog = () => {
    setFileSuccessDialog(!fileSuccessDialog);
  };
  const toggleFileNotChosenDialog = () => {
    setFileNotChosenDialog(!fileNotChosenDialog);
    setLoader(false);
  };
  console.log("user id print", userId);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  useEffect(() => {
    let api = ApiServices.getInstance();
    console.log("account instance id value", accountInstance.accntId);
    console.log("sub value", sub);
    if (accountInstance.accntId && sub) {
      api
        .makeRequest(
          `${accountInstance.accntId}/customersadmin/${subRef.current}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("data role in personal settings error", data?.role);
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setUserId(data.userId);
            console.log("data print adfasfasdasdafsdfdsfdsa", data);
          }
        });
    }
  }, [accountInstance.accntId, sub]);

  console.log("loader value print", loader);

  const toggleFileNotLoadingDialog = () => {
    setFileNotLoadingDialog(true);
  };

  const handleLinkClick = (e: { preventDefault: () => void }) => {
    setLoader(false);
    e.preventDefault(); // Prevent default anchor click behavior
    console.log("Link clicked");
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/user/upload/template`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("response", res);
          setUploadUser(res);

          if (res?.link) {
            const link = document.createElement("a");
            link.href = res.link; // Use the link from the response
            link.download = "template.xlsx"; // You can dynamically generate the filename if needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          toggleTemplateSuccessDialog();
          // toast.success("Template file downloaded successfully");
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  };
  const checkAndUploadToS3 = () => {
    setLoader(true);
    if (uploadFile !== undefined) {
      // toast.custom(<Loading />, { duration: Infinity });
      uploadIntoS3(uploadFile);
    } else {
      // toast.error("File not chosen!");
      toggleFileNotChosenDialog();
    }
  };
  const uploadIntoS3 = (e: any) => {
    const date = new Date();
    const timeEpoch = date.getTime();

    ("Mikros-Users/acct-b608ae57-048d-470c-be2224df49bec360/useruploads/1741606840427/employee_data_500_no_other_2.csv-1741606840427.csv");

    const filePathUrl = `acct-${accountInstance.accntId}/${userId}/useruploads/${timeEpoch}/${e.target.files[0].name}-${timeEpoch}.csv`;
    const file = e.target.files[0];
    let s3 = S3Service.getInstance();
    s3.writeFileInFolder(filePathUrl, file, "Mikros-Users")
      .then((res) => {
        let body = {
          userId: userId,
          path: `Mikros-Users/acct-${accountInstance.accntId}/${userId}/useruploads/${timeEpoch}/${e.target.files[0].name}-${timeEpoch}.csv`,
        };
        let api = ApiServices.getInstance();
        if (accountInstance.accntId) {
          api
            .makeRequest(`${accountInstance.accntId}/user/upload`, "POST", body)
            .then(async (data) => {
              if (data && data.errorMessage) {
                setErrorFlag(true);
                await errorInstance.updateErrorCode(data.errorMessage);
                return;
              }

              console.log("print response", data);
              // toast.success("file upload successful");
              toggleFileSuccessDialog();
            })
            .catch((err) => {
              toast.error(err);
            });
        }
      })
      .catch((e) =>
        //  toast.error("Something went wrong!")
        toggleFileNotLoadingDialog()
      );
  };

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div className="relative">
      {fileNotLodingDialog && (
        <Dialog className="alertDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "users.uploadFile.errorUploadFile",
            })}`}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"alertShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgAlert",
            })}
            backgroundColor={"mk-orange"}
            onClick={() => {
              toggleFileNotLoadingDialog();
            }}
          />
        </Dialog>
      )}
      {loader && (
        // <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-10">
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-10 z-10">
          <LoaderFileUpload />
        </div>
      )}
      {downloadSuccessDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.uploadFile.templateFileSuccess",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleTemplateSuccessDialog();
            }}
          />
        </Dialog>
      )}
      {fileSuccessDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "user.userUploadFileSuccess",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleFileSuccessDialog();
              if (props.uploadDialogFunction) {
                console.log(
                  "upload dialog function value",
                  props.uploadDialogFunction
                );

                props.uploadDialogFunction(!props.uploadDialogValue);
              }
              if (props.triggerFetchAll) {
                console.log("entered fetch all user function");
                props.triggerFetchAll(true);
              }
            }}
          />
        </Dialog>
      )}
      {fileNotChosenDialog && (
        <Dialog className="alertDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.uploadFile.fileNotChoosen",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"alertShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgAlert",
            })}
            backgroundColor={"mk-orange"}
            onClick={() => {
              toggleFileNotChosenDialog();
            }}
          />
        </Dialog>
      )}
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/users");
              }
            }}
          />
        </Dialog>
      )}

      <div className="flex items-center border-b px-4">
        <div className="flex-1">
          <RoundedTabGroup defaultTabName="uploadFile" onClick={resetTabs}>
            <RoundedTab
              name="uploadFile"
              title={intl.formatMessage({ id: "searchUser.uploadFileTab" })}
            >
              <div className="input-container pl-4">
                <a
                  href={uploadUser?.link}
                  className="text-mk-primary-bright pointer-cursor "
                  onClick={handleLinkClick}
                >
                  <div className="p-3"></div>
                  {/* Use our batch upload template file */}
                  {intl.formatMessage({
                    id: "searchUser.uploadUser.batchUpload",
                  })}
                </a>
                <div className="file-upload-container">
                  <input
                    type="file"
                    onChange={(e) => setUploadFile(e)}
                    id="fileInput"
                    accept=".csv"
                    multiple={false}
                  />
                </div>
                <div className="flex justify-end gap-4 mt-4">
                  <Button
                    themeColor="primary"
                    onClick={() => {
                      checkAndUploadToS3();
                    }}
                  >
                    <FormattedMessage id="users.createStaticList.uploadFile" />
                  </Button>
                  <Button
                    themeColor="primary"
                    onClick={() => {
                      if (props.uploadDialogFunction) {
                        props.uploadDialogFunction(false);
                      }
                    }}
                  >
                    <FormattedMessage id="cancelButton" />
                  </Button>
                </div>
              </div>
            </RoundedTab>
            <RoundedTab
              name="require"
              title={intl.formatMessage({ id: "searchUser.requireTab" })}
            >
              <div className="p-3"></div>
              <div className="space-y-1.5 pl-4">
                <div>
                  {" "}
                  <FormattedMessage id="searchUser.uploadUser.requireTab.usersStatement" />{" "}
                  <b>
                    {" "}
                    <FormattedMessage id="searchUser.uploadUser.requireTab.usersNo" />
                  </b>
                  .
                </div>
                <div>
                  {" "}
                  <FormattedMessage id="searchUser.invalidField" />
                </div>

                <ul className="list-disc pl-8">
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.employeeId" />
                    </b>{" "}
                    <FormattedMessage id="searchUser.employeeIdLimit" />
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.firstName" />{" "}
                    </b>
                    <FormattedMessage id="searchUser.firstNameLimit" />
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.lastName" />
                    </b>{" "}
                    <FormattedMessage id="searchUser.firstNameLimit" />
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.email" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.emailSpecify" />
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.mobileNumber" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.mobileNumberSpecify" />
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.dateOfJoining" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.dateFormat" />{" "}
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.lastWorkingDate" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.dateFormat" />{" "}
                  </li>
                  <li>
                    <b>
                      <FormattedMessage id="searchUser.dateOfBirth" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.dateFormat" />{" "}
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.gender" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.genderSpecify" />{" "}
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.language" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.languageLimit" />
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.department" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.departmentLimit" />{" "}
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.designation" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.designationLimit" />
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.location" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.locationLimit" />{" "}
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.branch" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.branchLimit" />{" "}
                  </li>
                  <li>
                    <b>
                      {" "}
                      <FormattedMessage id="searchUser.status" />{" "}
                    </b>{" "}
                    <FormattedMessage id="searchUser.statusValidation" />{" "}
                  </li>
                </ul>
              </div>
            </RoundedTab>
          </RoundedTabGroup>
        </div>

        <IconButton
          className="self-start mt-2"
          // className="self-start mt-2 bg-gray-200 hover:bg-gray-300 rounded-full p-1"
          sx={{
            backgroundColor: "gray.200",
            "&:hover": {
              backgroundColor: "gray.300",
            },
            borderRadius: "50%",
            padding: "8px",
          }}
          onClick={() => {
            if (props.uploadDialogFunction) {
              props.uploadDialogFunction(false);
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
}
